var recentlyViewedSection = document.querySelector('.recently-viewed--section .product-recently-viewed--section');
var featuredCollectionSection = document.querySelector('.featured-collection-alt--section .hidden');

// if recently viewed does not have hide, unhide. Else unhide featured collection
if (featuredCollectionSection && recentlyViewedSection && recentlyViewedSection.classList.contains('hide')) {
  featuredCollectionSection.classList.remove('hidden');
}

// observe recently viewed until it is hidden, then unhide featured collection
if (recentlyViewedSection) {
  const recentlyViewedSectionObserver = new MutationObserver(function () {
    if (recentlyViewedSection.classList.contains('hide')) {
      recentlyViewedSectionObserver.disconnect();
      featuredCollectionSection.classList.remove('hidden');
    }
  });
  recentlyViewedSectionObserver.observe(recentlyViewedSection, {attributes: true, attributeFilter: ['class']});
}